import { Factory } from 'fishery'

// eslint-disable-next-line no-restricted-imports
import { ProductCollection } from '@/components/types'

export default Factory.define<ProductCollection>(({ sequence }) => ({
  id: sequence.toString(),
  name: 'A Collection'
}))
